import React, { useEffect, useState } from "react";
import { portalApi } from "../../lib/portalApi";
import { BookOpen, CheckCircle2, FileText, Users2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";

export default function CurriculumTab() {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    portalApi.curriculumSections().then(r => setSections(r.sections || []));
  }, []);

  return (
    <div className="space-y-4" data-testid="admin-curriculum-tab">
      <div className="glass p-5 flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-steel">Certification Curriculum</div>
          <h3 className="text-cream font-display text-xl mt-1">{sections.length} Sections · pass score 9.2 / 10</h3>
          <p className="text-cream-dim text-sm mt-1">Curriculum content is versioned and seeded on deploy. Manage student progress via User Management.</p>
        </div>
        <div className="flex gap-2">
          <Link to="/portal/curriculum">
            <Button className="btn-ghost-gold h-10 px-4 text-xs" data-testid="curriculum-admin-preview">
              <BookOpen size={14} className="mr-2" /> Preview as Learner
            </Button>
          </Link>
          <Link to="/portal/users">
            <Button className="btn-ghost-gold h-10 px-4 text-xs">
              <Users2 size={14} className="mr-2" /> Manage Students
            </Button>
          </Link>
        </div>
      </div>

      <div className="space-y-2">
        {sections.map(s => (
          <div key={s.id} className="glass p-4" data-testid={`curriculum-row-${s.order}`}>
            <div className="flex items-start gap-4">
              <div className="text-gold font-display text-2xl w-10 shrink-0">{s.order}</div>
              <div className="flex-1">
                <div className="text-cream font-medium">{s.title}</div>
                <div className="text-cream-dim text-xs mt-1 flex items-center gap-3 flex-wrap">
                  <span className="flex items-center gap-1"><CheckCircle2 size={12} className="text-[color:var(--auditiq-success)]" /> {s.lessons?.length || 0} lessons</span>
                  <span className="flex items-center gap-1"><FileText size={12} className="text-electric" /> {s.questions} Q · pass {s.pass_score}/10</span>
                  <span className="text-steel">{s.assessment}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
        {!sections.length && <div className="glass p-8 text-center text-cream-dim italic">Loading curriculum…</div>}
      </div>
    </div>
  );
}
